import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { GENERIC_DESCRIPTION, GENERIC_TITLE, HOMEPAGE_DESCRIPTION, HOMEPAGE_TITLE, SITE_URL, organizationJsonLdText } from '../seo/homepage_seo.js'

const CANONICAL_ID = 'home-canonical'
const JSONLD_ID = 'home-organization-jsonld'

const setDescription = (content: string) => {
  let meta = document.querySelector('meta[name="description"]')

  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    document.head.appendChild(meta)
  }

  meta.setAttribute('content', content)
}

const ensureCanonical = () => {
  let link = document.getElementById(CANONICAL_ID) as HTMLLinkElement | null

  if (!link) {
    link = document.createElement('link')
    link.id = CANONICAL_ID
    link.rel = 'canonical'
    document.head.appendChild(link)
  }

  link.href = SITE_URL
}

const ensureJsonLd = () => {
  let script = document.getElementById(JSONLD_ID) as HTMLScriptElement | null

  if (!script) {
    script = document.createElement('script')
    script.id = JSONLD_ID
    script.type = 'application/ld+json'
    document.head.appendChild(script)
  }

  script.text = organizationJsonLdText()
}

const removeHomepageSchema = () => {
  document.getElementById(CANONICAL_ID)?.remove()
  document.getElementById(JSONLD_ID)?.remove()
}

const HomepageDocumentMeta = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/') {
      document.title = HOMEPAGE_TITLE
      setDescription(HOMEPAGE_DESCRIPTION)
      ensureCanonical()
      ensureJsonLd()
      return
    }

    document.title = GENERIC_TITLE
    setDescription(GENERIC_DESCRIPTION)
    removeHomepageSchema()
  }, [location.pathname])

  return null
}

export { HomepageDocumentMeta }
